const warningId = 'houseBurnedWarning';
const dialogId = `${warningId}dialog`;
const burnedBtnId = 'closeBurnedWarningBtn';

let disabled = false;

/**
 * Show an on-screen warning that a house has burned
 **/
function showHouseBurnedWarning() {
	if(disabled) {
		return;
	}

	if(document.getElementById(warningId)) {
		return;
	}

	const warningContainer = document.createElement('div');
	warningContainer.id = warningId;
	warningContainer.classList.add('house-burned-warning');

	const dialog = document.createElement('div');
	dialog.id = dialogId;
	dialog.className = 'house-burned-warning__dialog';
	dialog.innerHTML
		= `<h2>Warning</h2>
		<div class="house-burned-warning__content">
			<p>Your protected area is burning!</p>
			<button id="${burnedBtnId}">OK</button>
		</div>`;

	const topLayer = document.querySelector('#canvas canvas:last-child');
	warningContainer.style = topLayer.style;

	topLayer.parentNode.insertBefore(warningContainer, topLayer);
	topLayer.parentNode.appendChild(dialog);

	const okBtn = document.getElementById(burnedBtnId);
	okBtn.addEventListener('click', (evt) => {
		evt.preventDefault();
		hideHouseBurnedWarning();
	});
}

/**
 * Hide a burned warning and prevent another dialog for 15 seconds
 **/
function hideHouseBurnedWarning() {
	const warning = document.getElementById(warningId);
	if(warning) {
		warning.parentNode.removeChild(warning);
	}

	const dialog = document.getElementById(dialogId);
	if(dialog) {
		dialog.parentNode.removeChild(dialog);
	}

	// Disable the warning for 15 seconds
	const disableDuration = 15000;
	disabled = true;
	setTimeout(() => { disabled = false; }, disableDuration);
}

/**
 * Allow the warning dialog to show again immediately
 **/
function enableWarning() {
	disabled = false;
}

export default showHouseBurnedWarning;

export {
	showHouseBurnedWarning,
	hideHouseBurnedWarning,
	enableWarning
}
